import { GetNetworkQuery } from '@coris-ts/repository/query/network.query'
import { type HttpParameters } from '@coris-ts/data/parameter-type'
import { ApiEndpoint } from '../../../../shared/api-endpoint'

export class GetUsersTotalsQuery extends GetNetworkQuery {
  constructor(private readonly organization: string) {
    super(ApiEndpoint.DashboardUsersTotals)
  }

  public get queryParameters(): HttpParameters {
    return {
      organization: this.organization
    }
  }
}

export class GetUsersMetricsQuery extends GetNetworkQuery {
  constructor(
    private readonly fromDate: string,
    private readonly toDate: string,
    private readonly fromPrevious: string,
    private readonly toPrevious: string,
    private readonly organization: string
  ) {
    super(ApiEndpoint.DashboardUsersMetrics)
  }

  public get queryParameters(): HttpParameters {
    return {
      from_date: this.fromDate,
      to_date: this.toDate,
      from_previous: this.fromPrevious,
      to_previous: this.toPrevious,
      organization: this.organization
    }
  }
}
